export enum AuthRouteKeys {
  Root = '/auth',
  Login = '/auth/login',
  OTP = '/auth/otp',
  NewPassword = '/auth/new-password',
  NewPasswordVerifByEmail = '/auth/new-password-verify-by-email',
}

export enum ErrorRouteKeys {
  Root = '/error',
  NotFound = '/error/404',
  Internal = '/error/500',
  NotAccess = '/error/403',
}

export enum MainRouteKeys {
  Root = '/',
  Personal = '/personal',
  PersonalInfo = '/personal/info',
  PersonalBalance = '/personal/balance',
  PersonalReward = '/personal/reward',
  PersonalRewardManage = '/personal/reward/manage',
  DepositFromMoraPay = '/personal/reward/deposit-from-morapay',
  WithdrawToMoraPay = '/personal/reward/withdraw-to-morapay',
  PersonalChangePassword = '/personal/change-password',
  BankManagement = '/personal/bank-management',
  PersonalLogout = '/personal/logout',
  Users = '/users',
  UpdateUser = '/update-user',
  Balance = '/balance',
  BalanceManage = '/balance/manage',
  Transfers = '/balance/transfers',
  TopUp = '/balance/topup',
  PayBill = '/pay-bill',
  PayBillElectric = '/pay-bill/electric',
  PayBillElectricDetails = '/pay-bill/electric/:orderCode',
  Transactions = '/transactions',
  TransactionBills = '/transactions/bills',
  TransactionBillDetails = '/transactions/bills/:transactionCode',
  Customers = '/customers',
  PointTransactions = '/transactions/points',
  PointRewardTransactions = '/transactions/point-reward-transactions',
  Orders = '/orders',
  TPBank = '/tpbank',
  TransactionsBank = '/transactionsbank',
  AccountBank = '/accountTPBank',
  RequestWithdraw = '/request-withdraw',
  RequestWithdrawOwn = '/request-withdraw/request-withdraw-own',
  CheckRequestWithdrawList = '/request-withdraw/check-request-withdraw',
  CreateRequestWithdraw = '/request-withdraw/create-request-withdraw',
  CompanyDepartment = '/company-department',
  Company = '/company-department/company',
  Refferal = '/refferal',
  RefferalDetail = '/refferal/manage',
  RefferalDetailHistory = '/refferal/history',
  AuditLogsAdmin = '/audit-logs-admin',
  // Energy Department Routes
  EnergyDepartment = '/energy-department',
  SupplierEnergy = '/energy-department/supplier',
  GasStation = '/energy-department/oil-store',
  BranchEnergy = '/energy-department/branch',
  TransactionEnergy = '/energy-department/transactions',
  // BIDV Virtual Account Routes
  BidvVirtualAccount = '/bidv-virtual-account',
  // BidvVirtualAccountList = '/bidv-virtual-account/list',
  BidvVirtualAccountInquiry = '/bidv-virtual-account/inquiry',
}
